import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_trend = (starttime, endtime, userName) => {
  return api.post(`${ApiEndpointConstants.GETTREND}`, {
    starttime,
    endtime,
    userName,
  });
};
